
import { Component, AfterContentInit, OnDestroy } from '@angular/core';
import { PlycaDataService } from '../../../services/plyca.service';
import { PaginationDTO } from '../../api/PaginationModel';
import { UIService } from '../../ui.service';
import {
  ConfigurationDTO,
  WSDefinitionHandlerAttributeDTO
} from '../../api/plyca-dtos-v2';
import { FieldConfig } from '../../api/contract-notice-dto';
import { BaseComponent } from '../../components/common/baseComponent/base.component';

@Component({
  selector: 'configuration',
  templateUrl: 'configuration.template.html'
})
export class configurationComponent extends BaseComponent
  implements AfterContentInit, OnDestroy {
  loaded = false;
  configurations: Array<ConfigurationDTO> = [];
  constructor(

    public plycaService: PlycaDataService,
    public uiService: UIService
  ) {
    super();
  }

  ngAfterContentInit(): void {
    this.subscribe(
      this.plycaService
        .getConfigurations()
      , (result: PaginationDTO<ConfigurationDTO>) => {
        if (result && result.content) {
          //          this.configurations = result.content;
          result.content.forEach(conf => {
            this.subscribe(
              this.plycaService
                .getConfiguration(conf.identifier, '0000')
              , configuration => {
                if (configuration.items) {
                  this.configurations.push(configuration);
                }
              });
          });
        }
        this.loaded = true;
      });
  }

  ngOnDestroy(): void {


  }

  public isLoaded(): boolean {
    return this.loaded;
  }

  public getFieldConfigWSAttributeHandler(attribute: WSDefinitionHandlerAttributeDTO): FieldConfig {
    let config = new FieldConfig();
    config.type = 'STRING';
    config.tooltipText = attribute.attributeType;
    config.jsonField = 'value';
    config.description = attribute.attributeType;
    return config;
  }
}
